import {
  Archive,
  ArrowRightLeft,
  BarChart3,
  Bitcoin,
  Building,
  Car,
  CheckCircle2,
  Clock,
  CreditCard,
  Database,
  FileText,
  GitMerge,
  IdCard,
  Image as ImageIcon,
  Link2,
  type LucideProps,
  MapPin,
  Mic,
  Scan,
  Scissors,
  Search,
  Table as TableIcon,
  Trash2,
  User,
  Wallet,
  Waves,
} from 'lucide-react'

export type PipelineIcon = React.ForwardRefExoticComponent<
  Omit<LucideProps, 'ref'> & React.RefAttributes<SVGSVGElement>
>

export const PIPELINE_ICON_MAP: Record<string, PipelineIcon> = {
  archive: Archive,
  'arrow-right-left': ArrowRightLeft,
  'bar-chart': BarChart3,
  bitcoin: Bitcoin,
  building: Building,
  car: Car,
  'check-circle-2': CheckCircle2,
  clock: Clock,
  'credit-card': CreditCard,
  database: Database,
  'file-text': FileText,
  'git-merge': GitMerge,
  'id-card': IdCard,
  image: ImageIcon,
  link: Link2,
  'link-2': Link2,
  'map-pin': MapPin,
  mic: Mic,
  scan: Scan,
  scissors: Scissors,
  search: Search,
  table: TableIcon,
  'trash-2': Trash2,
  user: User,
  wallet: Wallet,
  waves: Waves,
}

export function getPipelineIcon(name: string): PipelineIcon {
  return PIPELINE_ICON_MAP[name] ?? FileText
}
